import { getAnalysisTypeDisplayName } from '@modules/dashboard/helpers';
import { FilterAltRounded } from '@mui/icons-material';
import { Stack, Typography, alpha } from '@mui/material';
import { AnalysisUseCase } from 'generated/graphql';

interface DashboardOrAnalysisFiltersPreviewTitleProps {
  analysisUseCase?: AnalysisUseCase;
  secondaryAction?: React.ReactNode;
  isDashboardVariant: boolean;
  title?: string;
}

export const DashboardOrAnalysisFiltersPreviewTitle = ({
  analysisUseCase,
  secondaryAction,
  isDashboardVariant,
  title,
}: DashboardOrAnalysisFiltersPreviewTitleProps) => {
  const getTitle = () => {
    if (title) {
      return title;
    }

    return isDashboardVariant
      ? 'Dashboard Filters'
      : `${getAnalysisTypeDisplayName(analysisUseCase)} Filters`;
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={0.5}
      sx={{
        borderBottom: '1px solid',
        borderColor: (theme) =>
          isDashboardVariant
            ? alpha(theme.palette.info.main, 0.2)
            : alpha(theme.palette.primary.main, 0.2),
        py: 0.5,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <FilterAltRounded
          sx={{
            color: isDashboardVariant ? 'info.main' : 'text.secondary',
            fontSize: '1rem',
          }}
        />
        <Typography variant="caption" color="text.secondary">
          {getTitle()}
        </Typography>
      </Stack>
      {secondaryAction}
    </Stack>
  );
};
